import { useEffect, useRef, useState } from 'react'
import cn from 'classnames'

import { CategoryDetailProps } from './interface'

export function CategoryDetail({ title, description }: CategoryDetailProps) {
  const contentRef = useRef<HTMLParagraphElement>(null)
  const [showMore, setShowMore] = useState({
    showButton: false,
    showLessContent: false,
  })

  function handleShowContent() {
    setShowMore(prev => ({ ...prev, showLessContent: !prev.showLessContent }))
  }

  useEffect(() => {
    const res = !!contentRef.current && contentRef.current.clientHeight >= 156
    setShowMore({
      showButton: res,
      showLessContent: res,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <article className='text-secondary dark:text-dark-10'>
      <h3 className='font-bold mb-[20px]'>{title}</h3>
      <p
        ref={contentRef}
        className={cn('text-[14px] font-light leading-[1.6]', {
          'line-clamp-6': showMore.showLessContent,
        })}
      >
        {description || '-'}
      </p>
      <div
        className={cn('text-center mt-[30px]', {
          hidden: !showMore.showButton,
        })}
      >
        <button
          type='button'
          className='text-primary text-[14px] font-medium font-mitr underline'
          onClick={handleShowContent}
        >
          {showMore.showLessContent ? 'แสดงทั้งหมด' : 'แสดงน้อยลง'}
        </button>
      </div>
    </article>
  )
}
